import React from "react";

const AboutMission = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10">
          <div>
            <span className="inline-block text-xs text-[#64748B] border border-[#E2E8F0] px-3 py-1 rounded-full mb-4">
              About Invexflow
            </span>

            <h2 className="text-2xl md:text-3xl font-semibold text-[#0F172A] leading-snug">
              We’re on a mission to make cash flow frictionless
            </h2>
          </div>

          <span className="inline-block mt-4 md:mt-0 bg-[#22C55E] text-white text-xs font-semibold px-3 py-1.5 rounded-full">
            Regulated partners
          </span>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <InfoCard
            title="Our story"
            text="Founded by operators and risk veterans, Invexflow combines modern underwriting with pragmatic finance to help businesses grow sustainably."
          />
          <InfoCard
            title="Our values"
            text="Transparency, speed, and partnership. We design products that put founders and finance teams first."
          />
          <InfoCard
            title="Security"
            text="Encryption at rest and in transit, continuous monitoring, and strict access controls."
          />
        </div>

        {/* Team */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
          <TeamCard
            name="Alex Carter"
            role="CEO & Co-founder"
            img="https://i.pravatar.cc/100?img=12"
          />
          <TeamCard
            name="Maya Patel"
            role="COO"
            img="https://i.pravatar.cc/100?img=32"
          />
          <TeamCard
            name="Daniel Kim"
            role="Head of Risk"
            img="https://i.pravatar.cc/100?img=54"
          />
          <TeamCard
            name="Sophia Li"
            role="Product Lead"
            img="https://i.pravatar.cc/100?img=47"
          />
        </div>

      </div>
    </section>
  );
};

/* ---------- Subcomponents ---------- */

const InfoCard = ({ title, text }) => (
  <div className="border border-[#E2E8F0] rounded-xl p-6">
    <h4 className="text-sm font-semibold text-[#0F172A] mb-2">
      {title}
    </h4>
    <p className="text-sm text-[#64748B] leading-relaxed">
      {text}
    </p>
  </div>
);

const TeamCard = ({ name, role, img }) => (
  <div className="border border-[#E2E8F0] rounded-xl p-6 text-center">
    <img
      src={img}
      alt={name}
      className="w-16 h-16 rounded-full mx-auto mb-3 object-cover"
    />
    <p className="text-sm font-semibold text-[#0F172A]">
      {name}
    </p>
    <p className="text-xs text-[#64748B]">
      {role}
    </p>
  </div>
);

export default AboutMission;
